/**
 * Money math. All amounts are integer base units (wei, satoshi, lamports, sun)
 * held as BigInt. Never use JavaScript numbers (floats) for money.
 */
const DECIMAL_STRING = /^(\d+)(?:\.(\d+))?$/;
function assertDecimals(decimals) {
    if (!Number.isInteger(decimals) || decimals < 0 || decimals > 36) {
        throw new RangeError(`Invalid decimals: ${decimals}`);
    }
}
/**
 * Convert a human amount ("1.5") to base units (1500000n for 6 decimals).
 * Rejects negatives, exponents and more fractional digits than `decimals`
 * instead of silently rounding.
 */
export function parseUnits(value, decimals) {
    assertDecimals(decimals);
    const match = DECIMAL_STRING.exec(value.trim());
    if (!match) {
        throw new Error(`Invalid amount: "${value}"`);
    }
    const whole = match[1] ?? "0";
    const fraction = match[2] ?? "";
    if (fraction.length > decimals) {
        throw new Error(`Amount "${value}" has more than ${decimals} decimal places`);
    }
    return BigInt(whole + fraction.padEnd(decimals, "0"));
}
/** Convert base units to a human string, without trailing zeros ("1.5", "0.000001", "12"). */
export function formatUnits(amount, decimals) {
    assertDecimals(decimals);
    const negative = amount < 0n;
    const digits = (negative ? -amount : amount).toString().padStart(decimals + 1, "0");
    const whole = digits.slice(0, digits.length - decimals);
    const fraction = digits.slice(digits.length - decimals).replace(/0+$/, "");
    return `${negative ? "-" : ""}${whole}${fraction ? `.${fraction}` : ""}`;
}
//# sourceMappingURL=money.js.map